import React from "react";
import Text from "@ui/Text";
import t from "../../../i18n";
import { css } from "@linaria/core";
import { color, fonts } from "@ui";

const container = css`
  display: inline-block;
  color: ${color.carbon900};
`;
const mainText = css`
  font: ${fonts.body1SemiBold};
`;
const secondaryText = css`
  font: ${fonts.body1};
`;
export const LoadedFileName = ({ fileName }: { fileName: string | null }) =>
  fileName ? (
    <div className={container}>
      <Text as="span" className={mainText}>
        {t("setup.import.fileName")}
      </Text>{" "}
      <Text as="span" className={secondaryText}>
        {fileName}
      </Text>
    </div>
  ) : null;
